import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'components/misc'
import { apiOrganizations } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { logError } from 'redux/modules/app'
import { selectMap } from 'redux/selectors/misc'
import { Select } from '../../../../components/fields'
import get from 'lodash/get'

@apiOrganizations({ disablePaging: true })
@form({
  form: 'manage-gop'
})
@connect(
  ({ auth, api }) => ({
    activeOrganization: auth.organization,
    organizations: api.organizations,
    gopList: selectMap(api.organizations.listGOPs),
    sgopList: selectMap(api.organizations.listSGOPs)
  }),
  {
    logError
  }
)
class OrganizationManageGOP extends Component {
  static propTypes = {
    gopList: PropTypes.array.isRequired,
    sgopList: PropTypes.array.isRequired,
    organizations: PropTypes.object.isRequired,
    assignGlobalOperatingPartner: PropTypes.func.isRequired,
    unassignGlobalOperatingPartner: PropTypes.func.isRequired,
    getSubGlobalOperatingPartner: PropTypes.func.isRequired,
    getAvailableGlobalOperatingPartner: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    values: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    organisationId: PropTypes.number.isRequired,
    gopId: PropTypes.number,
    sgopId: PropTypes.number,
    initialize: PropTypes.func.isRequired,
    activeOrganization: PropTypes.object.isRequired
  }

  static defaultProps = {
    values: {},
    organisationId: null,
    gopId: null,
    sgopId: null
  }

  componentWillReceiveProps(nextProps) {
    const { organisationId } = this.props

    if (organisationId !== nextProps.organisationId) {
      this.props.getAvailableGlobalOperatingPartner(nextProps.organisationId)
    }
  }

  componentDidMount() {
    const { organisationId, gopId, sgopId } = this.props

    this.props.getAvailableGlobalOperatingPartner(organisationId)
    gopId && this.props.getSubGlobalOperatingPartner(organisationId, gopId)
    gopId && this.props.initialize({ gopId, sgopId })

  }

  handleGOPSelected = item => {
    const { organisationId } = this.props

    const gopId = get(item, 'value')

    gopId && this.props.getSubGlobalOperatingPartner(organisationId, gopId)
  }

  handleSGOPSelected = () => {
  }

  handleRemove = () => {
    const { organisationId } = this.props

    this.props.unassignGlobalOperatingPartner(organisationId)
  }

  handleSubmit = fields => {
    const { organisationId } = this.props

    this.props.assignGlobalOperatingPartner(organisationId, get(fields, 'gopId'), get(fields, 'sgopId'))
  }

  render() {
    const {
      gopList,
      sgopList,
      gopId,
      organizations,
      handleSubmit,
      values,
      submitting
    } = this.props

    const gopIdValue = get(values, 'gopId')

    const sgopIdValue = get(values, 'sgopId')

    const disableSubmit = gopList.length > 0 && (!gopIdValue || organizations.loading || gopIdValue === gopId)
        || (gopIdValue && sgopList && sgopList.length > 0 && !sgopIdValue)

    const alreadyInGOP = gopId && gopId > 0

    const disableSGOP = organizations.loading || submitting || !(sgopList && sgopList.length > 0) || !gopIdValue

    const disableRemove = !alreadyInGOP || get(organizations, 'gops.removing')

    return (

      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className="row">
          <div className="col-xs-12">
            <h2 className="text--center">
              <FormattedMessage
                id="organisation.manage_gop"
                defaultMessage="Manage Global Operating Partner"
              />
            </h2>
          </div>
          <div className="col-xs-12">
            <div className="base-margin--bottom">
              <Select
                  name="gopId"
                  label="Global Operating Partner"
                  options={gopList}
                  loading={organizations.loading && gopList.length === 0}
                  disabled={organizations.loading || submitting}
                  onSelectChange={item => this.handleGOPSelected(item)}
              />
            </div>
          </div>

          <div className="col-xs-12">
            <div className="base-margin--bottom">
              <Select
                  name="sgopId"
                  label="Sub-Global Operating Partner"
                  options={sgopList}
                  loading={organizations.loading && sgopList.length === 0}
                  disabled={disableSGOP}
                  onSelectChange={this.handleSGOPSelected()}
              />
            </div>
          </div>

        </div>
        <div className="row">
          <div style={{ width: '20%', float: 'left', paddingLeft: '15px' }}>
            <Button
              type="button"
              onClick={this.props.onClose}
              secondary
              intlKey="button.close"
            >
              Close
            </Button>
          </div>
          <div style={{ width: '80%', float: 'right', paddingLeft: '24%' }}>
            <div className="btn-group" role="group">
            <Button
                type="button"
                negative
                disabled={disableRemove}
                intlKey="button.unassign"
                onClick={() => this.handleRemove()}
                isLoading={disableRemove && get(organizations, 'gops.removing')}
            >
              Unassign
            </Button>
            <Button
              style={{ marginLeft: '8px' }}
              disabled={disableSubmit}
              intlKey="button.assign"
              isLoading={disableSubmit && organizations.loading}
            >
              Assign
            </Button>
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default OrganizationManageGOP
